import React from 'react';
import { PeopleIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipStates = {
  Active: 'success',
  Draft: 'default',
  Expired: 'error',
  Cancelled: 'error',
  Suspended: 'warning',
  'Pending Acceptance': 'default',
  'Pending Activation': 'default',
};

function renderItem(subscription, t): Nullable<SearchItemViewModel> {
  return {
    title: subscription['Name'],
    descriptionFields: [
      {
        type: 'Text',
        value: subscription['Account.Name'],
        title: subscription['Account.Name'],
      },
      {
        type: 'Text',
        value: subscription['Account.AccountNumber'],
        title: subscription['Account.AccountNumber'],
      },
      {
        type: 'Date',
        value: subscription['ContractEffectiveDate'],
        title: t('Subscription.ContractEffectiveDate'),
      },
    ],
    chipField: {
      label: t(`Subscription.Status.${subscription['Status']}`),
      state: chipStates[subscription['Status']],
    },
    href: convertToBillingUrl(
      `/apps/Subscription.do?method=view&id=${subscription.Id}`,
    ),
  };
}

export const Subscription: SearchMeta = {
  objectType: 'Subscription',
  objectLabelI18n: 'Subscription.TabLabel',
  needsPermission: false,
  tabIcon: <PeopleIcon />,
  listPageUrl: convertToBillingUrl('/apps/Subscription.do'),
  hasAdvancedSearch: true,
  renderItem,
};
